<template>
  <div class="pages">
    <div class="pagesContent">
      <div class="bottomeContent">
        <div class="title">
          <div class="name">{{contentTitle}}</div>
          <div class="engName">{{englishName}}</div>
        </div>
        <div class="compContent">
          <div class="leftNav bl">
            <div :class="['item','fz22', activeName === item.name ? 'itemActive':'']" v-for="item in leftData.navs"
              :key="item.name" @click="changeTab(item)">
              {{item.text}}
            </div>
          </div>
          <contactWay v-if="$route.params.pathId === 'contactWay'"></contactWay>
          <contactMedia v-if="$route.params.pathId === 'contactMedia'"></contactMedia>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import contactWay from '@/components/contactWay'
  import contactMedia from '@/components/contactMedia'
  export default {
    name: 'about',
    components: {
      contactWay,
      contactMedia
    },
    data() {
      return {
        leftData: {
          title: '联系我们',
          navs: [{
            name: 'contactWay',
            text: '联系方式',
            fatherPath: 'contact',
            english: 'CONTACT US'
          },
          // {
          //   name: 'contactMedia',
          //   text: '自媒体',
          //   fatherPath: 'contact',
          //   english: 'WE MEDIA'
          // },
          ]
        },
        activeName: 'contactWay'
      }
    },
    computed: {
      contentTitle(){
        return this.leftData.navs.find(item=>item.name === this.$route.params.pathId).text
      },
      englishName(){
        return this.leftData.navs.find(item=>item.name === this.$route.params.pathId).english
      }
    },
    created() {
      this.activeName = this.$route.params.pathId
    },
    mounted() {},
    methods: {
      changeTab(item) {
        if (this.activeName === item.name) return
        this.activeName = item.name
        this.$router.push({
          path: `/${item.fatherPath}/${item.name}`
        })
        this.$forceUpdate()
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .title{
    margin-top: 56px;
  }
  .compContent {
    width: 1024px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .leftNav{
      width: 196px;
      .item{
        width: 196px;
        height: 94px;
        line-height: 94px;
        text-align: center;
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
      }
      .itemActive{
        color: #2488CA;
      }
    }
  }
</style>